import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserConsent } from '../../../../../apex/src/app/features/user-consent/models/user-consent.model';
import { UserConsentService } from '../../../../../apex/src/app/features/user-consent/services/user-consent.service';

export const PortalApartmentUserConsentsResolver: ResolveFn<UserConsent[]> = (route) => {
  const userConsentService = inject(UserConsentService);

  const apartmentId = Number(route.paramMap.get('ApartmentId'));

  if (!apartmentId || apartmentId <= 0) {
    throw new Error('Apartment id is required');
  }

  return userConsentService.getUserConsentsForApartment(apartmentId);
};
